export default (function (value) {
  return !value.match(/[\+\=?!@%&<>\[\]{}()<>|$€£#\/\\]/);
});